export default __webpack_public_path__ + "static/media/080_finish_bad.last.05c40849.avif";